// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Custom application mixins available through out the app
 */

/* Define CSS classes for property variants */
.mt-md {
  margin-top: 1.5rem;
}

.mt-md-n {
  margin-top: -1.5rem;
}

.mt-lg {
  margin-top: 2.25rem;
}

.mt-lg-n {
  margin-top: -2.25rem;
}

.mt-sm {
  margin-top: 0.75rem;
}

.mt-sm-n {
  margin-top: -0.75rem;
}

.mt-xs {
  margin-top: 0.375rem;
}

.mt-xs-n {
  margin-top: -0.375rem;
}

.mt-0 {
  margin-top: 0;
}

.mt-0-n {
  margin-top: 0;
}

.mb-md {
  margin-bottom: 1.5rem;
}

.mb-md-n {
  margin-bottom: -1.5rem;
}

.mb-lg {
  margin-bottom: 2.25rem;
}

.mb-lg-n {
  margin-bottom: -2.25rem;
}

.mb-sm {
  margin-bottom: 0.75rem;
}

.mb-sm-n {
  margin-bottom: -0.75rem;
}

.mb-xs {
  margin-bottom: 0.375rem;
}

.mb-xs-n {
  margin-bottom: -0.375rem;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-0-n {
  margin-bottom: 0;
}

.ml-lg {
  margin-left: 20px;
}

.ml-lg-n {
  margin-left: -20px;
}

.ml-md {
  margin-left: 15px;
}

.ml-md-n {
  margin-left: -15px;
}

.ml-sm {
  margin-left: 10px;
}

.ml-sm-n {
  margin-left: -10px;
}

.ml-xs {
  margin-left: 5px;
}

.ml-xs-n {
  margin-left: -5px;
}

.ml-0 {
  margin-left: 0;
}

.ml-0-n {
  margin-left: 0;
}

.mr-lg {
  margin-right: 20px;
}

.mr-lg-n {
  margin-right: -20px;
}

.mr-md {
  margin-right: 15px;
}

.mr-md-n {
  margin-right: -15px;
}

.mr-sm {
  margin-right: 10px;
}

.mr-sm-n {
  margin-right: -10px;
}

.mr-xs {
  margin-right: 5px;
}

.mr-xs-n {
  margin-right: -5px;
}

.mr-0 {
  margin-right: 0;
}

.mr-0-n {
  margin-right: 0;
}

.opacity-10 {
  opacity: 0.1;
}

.opacity-20 {
  opacity: 0.2;
}

.opacity-30 {
  opacity: 0.3;
}

.opacity-40 {
  opacity: 0.4;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-60 {
  opacity: 0.6;
}

.opacity-70 {
  opacity: 0.7;
}

.opacity-80 {
  opacity: 0.8;
}

.opacity-90 {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["/**\n * Custom application mixins available through out the app\n */\n\n/* Define CSS classes for property variants */\n.mt-md {\n  margin-top: 1.5rem;\n}\n\n.mt-md-n {\n  margin-top: -1.5rem;\n}\n\n.mt-lg {\n  margin-top: 2.25rem;\n}\n\n.mt-lg-n {\n  margin-top: -2.25rem;\n}\n\n.mt-sm {\n  margin-top: 0.75rem;\n}\n\n.mt-sm-n {\n  margin-top: -0.75rem;\n}\n\n.mt-xs {\n  margin-top: 0.375rem;\n}\n\n.mt-xs-n {\n  margin-top: -0.375rem;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mt-0-n {\n  margin-top: 0;\n}\n\n.mb-md {\n  margin-bottom: 1.5rem;\n}\n\n.mb-md-n {\n  margin-bottom: -1.5rem;\n}\n\n.mb-lg {\n  margin-bottom: 2.25rem;\n}\n\n.mb-lg-n {\n  margin-bottom: -2.25rem;\n}\n\n.mb-sm {\n  margin-bottom: 0.75rem;\n}\n\n.mb-sm-n {\n  margin-bottom: -0.75rem;\n}\n\n.mb-xs {\n  margin-bottom: 0.375rem;\n}\n\n.mb-xs-n {\n  margin-bottom: -0.375rem;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.mb-0-n {\n  margin-bottom: 0;\n}\n\n.ml-lg {\n  margin-left: 20px;\n}\n\n.ml-lg-n {\n  margin-left: -20px;\n}\n\n.ml-md {\n  margin-left: 15px;\n}\n\n.ml-md-n {\n  margin-left: -15px;\n}\n\n.ml-sm {\n  margin-left: 10px;\n}\n\n.ml-sm-n {\n  margin-left: -10px;\n}\n\n.ml-xs {\n  margin-left: 5px;\n}\n\n.ml-xs-n {\n  margin-left: -5px;\n}\n\n.ml-0 {\n  margin-left: 0;\n}\n\n.ml-0-n {\n  margin-left: 0;\n}\n\n.mr-lg {\n  margin-right: 20px;\n}\n\n.mr-lg-n {\n  margin-right: -20px;\n}\n\n.mr-md {\n  margin-right: 15px;\n}\n\n.mr-md-n {\n  margin-right: -15px;\n}\n\n.mr-sm {\n  margin-right: 10px;\n}\n\n.mr-sm-n {\n  margin-right: -10px;\n}\n\n.mr-xs {\n  margin-right: 5px;\n}\n\n.mr-xs-n {\n  margin-right: -5px;\n}\n\n.mr-0 {\n  margin-right: 0;\n}\n\n.mr-0-n {\n  margin-right: 0;\n}\n\n.opacity-10 {\n  opacity: 0.1;\n}\n\n.opacity-20 {\n  opacity: 0.2;\n}\n\n.opacity-30 {\n  opacity: 0.3;\n}\n\n.opacity-40 {\n  opacity: 0.4;\n}\n\n.opacity-50 {\n  opacity: 0.5;\n}\n\n.opacity-60 {\n  opacity: 0.6;\n}\n\n.opacity-70 {\n  opacity: 0.7;\n}\n\n.opacity-80 {\n  opacity: 0.8;\n}\n\n.opacity-90 {\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
